<template>
  <div class="txn-wrap">
    <div id="blockSize" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  name: 'BlockSize',
  data() {
    return {
      chart: null,
      intervalId: null,
      option: {
        grid: {
          left: '1%',
          right: '10%',
          bottom: '0%',
          top: '8%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisLabel: {
            fontSize: 12,
            rotate: 35,
            interval: 0,
            textStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            // 去掉刻度
            show: false
          },
          axisLine: {
            // 修改轴线颜色
            lineStyle: {
              color: '#306269'
            }
          },
          name: '字节', // 在 x 轴末尾添加描述
          nameLocation: 'end', // 指定描述位置为末尾
          nameTextStyle: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#306269',
              width: 0.4
            }
          },
          axisLabel: {
            fontSize: 12,
            textStyle: {
              color: '#fff'
            }
          }
        },

        series: [
          {
            type: 'bar',
            type: 'scatter',
            symbol: 'circle', // 设置符号形状为空心椭圆
            symbolSize: [40, 20],
            itemStyle: {
              borderWidth: 0.5,
              borderColor: '#00CBFF',
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(4,24,32,0.8)'
                },
                {
                  offset: 0.5,
                  color: 'rgba(0,203,255,0.8)'
                },
                {
                  offset: 1,
                  color: 'rgba(0,203,255,0.4)'
                }
              ])
            }
          }
        ]
      }
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },
  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    initChart() {
      let container = document.getElementById('blockSize')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    getData() {
      let cid = this.$store.state.home.chainCid
      let params = {
        chain_id: cid,
        data_type: 5,
        query_range: 0,
        query_step: '',
        query_time: Math.floor(Date.now() / 1000)
      }
      this.$apis.home.getSingle(params).then(res => {
        if (res.data) {
          let xArray = ['0']
          var seriesArray = [{ data: [] }]
          let numArray = []
          res.data.map((item, index) => {
            xArray.push(item.axis)

            if (item.nums == 0) {
              seriesArray[0].data.push(null)
            } else {
              seriesArray[0].data.push(item.nums)
            }
            numArray.push(item.nums)
          })

          const numericArray = xArray.map(value => {
            if (value === 'Inf') {
              return Infinity
            } else {
              return parseFloat(value)
            }
          })
          numericArray.sort((a, b) => a - b)

          const newArray = numericArray
            .map((value, index, array) => {
              if (index === 0 && array.length > 1) {
                return `${value}-${array[index + 1]}`
              } else if (index < array.length - 1) {
                return `${array[index - 1]}-${value}`
              } else {
                return `${array[index - 1]}-${value}`
              }
            })
            .filter((value, index, array) => value !== array[index - 1])

          const maxVal = Math.max.apply(null, numArray.flat())
          this.max = Math.ceil(maxVal + maxVal / 2)
          this.chart.setOption({
            xAxis: {
              data: newArray
            },
            yAxis: {
              min: this.min,
              max: this.max
            },
            series: seriesArray
          })
        }
      })
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.real-wrap,
.line-chart {
  @include px2vw(width, 400);
  @include px2vw(height, 240);
  @include px2vw(margin-left, 20);
}
</style>
